// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hZJSFB {
  display: flex;
  height: 100%;
  overflow: hidden;
  padding: var(--spacing-3) 0;
}

.MtZP3I {
  align-items: start;
  flex: 1;
  padding: 0 var(--spacing-3);
  display: flex;
  flex-direction: row;
  gap: var(--spacing-3);
}

.AXnuLR {
  width: var(--spacing-4);
  height: var(--spacing-4);
  border-radius: 50%;
  background: var(--surface-neutral-subtle);
  display: flex;
  align-items: center;
  justify-content: center;
}

.PoHH3m {
  width: var(--spacing-2);
  height: var(--spacing-2);
}

.r4HBC5 {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-0-5);
}

.hPPqxG {
  font-family: var(--font-family-base);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  line-height: 32px;
  color: var(--text-neutral-dark);
  margin: 0;
}

.LwZA6V,
.eLDw0W,
.eCypzE {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-100);
  color: #000;
  margin: 0;
}

.c6MXft {
  background: var(--stroke-neutral-subtle);
  height: 100%;
  width: 1px;
}

/* Responsive design */
@media (max-width: 768px) {
  .hZJSFB {
    flex-direction: column;
  }

  .c6MXft {
    width: 100%;
    height: 1px;
    margin: 0;
  }

  .MtZP3I {
    padding: var(--spacing-3);
  }

  .efADIB {
    gap: var(--spacing-1-5);
  }

  .AXnuLR {
    width: var(--spacing-5);
    height: var(--spacing-5);
  }

  .pZtR2S {
    width: var(--spacing-3);
    height: var(--spacing-3);
  }

  .PrYu_X {
    font-size: var(--font-size-sm);
  }

  .LwZA6V,
  .DyEI3a,
  .qwA_Cf {
    font-size: var(--font-size-xs);
  }
}

@media (max-width: 480px) {
  .MtZP3I {
    padding: var(--spacing-2);
  }

  .efADIB {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacing-1);
  }

  .AXnuLR {
    width: var(--spacing-4);
    height: var(--spacing-4);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/EmissorCardTrackingPage/components/TrackingInfo/TrackingInfo.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,iBAAiB;EACjB,+BAA+B;EAC/B,SAAS;AACX;;AAEA;;;EAGE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;EACnC,WAAW;EACX,SAAS;AACX;;AAEA;EACE,wCAAwC;EACxC,YAAY;EACZ,UAAU;AACZ;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,SAAS;EACX;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;;;IAGE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;AACF","sourcesContent":[".trackingInfo {\n  display: flex;\n  height: 100%;\n  overflow: hidden;\n  padding: var(--spacing-3) 0;\n}\n\n.infoSection {\n  align-items: start;\n  flex: 1;\n  padding: 0 var(--spacing-3);\n  display: flex;\n  flex-direction: row;\n  gap: var(--spacing-3);\n}\n\n.iconContainer {\n  width: var(--spacing-4);\n  height: var(--spacing-4);\n  border-radius: 50%;\n  background: var(--surface-neutral-subtle);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.icon {\n  width: var(--spacing-2);\n  height: var(--spacing-2);\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-0-5);\n}\n\n.title {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  line-height: 32px;\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.addressText,\n.email,\n.name {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-100);\n  color: #000;\n  margin: 0;\n}\n\n.separator {\n  background: var(--stroke-neutral-subtle);\n  height: 100%;\n  width: 1px;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .trackingInfo {\n    flex-direction: column;\n  }\n\n  .separator {\n    width: 100%;\n    height: 1px;\n    margin: 0;\n  }\n\n  .infoSection {\n    padding: var(--spacing-3);\n  }\n\n  .sectionHeader {\n    gap: var(--spacing-1-5);\n  }\n\n  .iconContainer {\n    width: var(--spacing-5);\n    height: var(--spacing-5);\n  }\n\n  .sectionIcon {\n    width: var(--spacing-3);\n    height: var(--spacing-3);\n  }\n\n  .sectionTitle {\n    font-size: var(--font-size-sm);\n  }\n\n  .addressText,\n  .contactName,\n  .contactEmail {\n    font-size: var(--font-size-xs);\n  }\n}\n\n@media (max-width: 480px) {\n  .infoSection {\n    padding: var(--spacing-2);\n  }\n\n  .sectionHeader {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: var(--spacing-1);\n  }\n\n  .iconContainer {\n    width: var(--spacing-4);\n    height: var(--spacing-4);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"trackingInfo": `hZJSFB`,
	"infoSection": `MtZP3I`,
	"iconContainer": `AXnuLR`,
	"icon": `PoHH3m`,
	"content": `r4HBC5`,
	"title": `hPPqxG`,
	"addressText": `LwZA6V`,
	"email": `eLDw0W`,
	"name": `eCypzE`,
	"separator": `c6MXft`,
	"sectionHeader": `efADIB`,
	"sectionIcon": `pZtR2S`,
	"sectionTitle": `PrYu_X`,
	"contactName": `DyEI3a`,
	"contactEmail": `qwA_Cf`
};
module.exports = ___CSS_LOADER_EXPORT___;
